var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargingTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 14.0003V16.0003M12.667 18.3336H11.0003C10.6467 18.3336 10.3076 18.1931 10.0575 17.9431C9.80746 17.693 9.66699 17.3539 9.66699 17.0003V13.0003C9.66699 12.6467 9.80746 12.3076 10.0575 12.0575C10.3076 11.8075 10.6467 11.667 11.0003 11.667H11.3337M17.3336 18.3336H17.6669C18.0206 18.3336 18.3597 18.1931 18.6098 17.9431C18.8598 17.693 19.0003 17.3539 19.0003 17.0003V13.0003C19.0003 12.6467 18.8598 12.3076 18.6098 12.0575C18.3597 11.8075 18.0206 11.667 17.6669 11.667H16.0003M13.667 11.667L13.0003 15.3337L15.667 14.667L15.0003 18.3336",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingTest);
export default __webpack_public_path__ + "static/media/ChargingTest.62c439f10ce13a3fded741f59a11cbbe.svg";
export { ForwardRef as ReactComponent };